/**
 * Matches the query against the name and description of a label.
 */
export function matchesQuery(query: string, name: string, description: string | null | undefined) {
  if (!query.trim()) return true

  const normalizedQuery = query.trim().toLowerCase()

  if (name.toLowerCase().includes(normalizedQuery)) return true
  if (description?.toLowerCase().includes(normalizedQuery)) return true

  return false
}
